import Image from 'next/image';

const ProductsIcon = ({ icon }) => (
  <Image
    src={`/static/images/icons/products/${icon}.svg`}
    layout="responsive"
    alt={icon}
    width={70}
    height={70}
    quality="100"
    priority
  />
);

const SolutionsIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/solutions/${icon}.svg`}
    layout="responsive"
    alt={icon}
    width={48}
    height={48}
    quality="100"
    priority
  />
);

const CustomersIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/customers/${icon}.svg`}
    layout="responsive"
    alt={icon}
    width={48}
    height={48}
    quality="100"
    priority
  />
);

const ResourcesIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/resources/${icon}.svg`}
    layout="responsive"
    alt={icon}
    width={32}
    height={32}
    quality="100"
    priority
  />
);

const CompanyIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/company/${icon}.svg`}
    layout="responsive"
    alt={icon}
    width={32}
    height={32}
    quality="100"
    priority
  />
);

const dropdownProducts = {
  annotate: {
    title: 'Annotate',
    content: [
      {
        href: '/rapid',
        icon: <ProductsIcon icon="rapid" />,
        title: 'Scale Rapid',
        text: 'The fastest way to production-quality labels.',
        type: 'big'
      },
      {
        href: '/studio',
        icon: <ProductsIcon icon="studio" />,
        title: 'Scale Studio',
        text: 'Labeling infrastructure for your workforce.',
        type: 'big'
      },
      {
        href: '/3d-sensor-fusion',
        icon: <ProductsIcon icon="3d-sensor-fusion" />,
        title: 'Scale 3D Sensor Fusion',
        text: 'Advanced annotations for LiDAR + RADAR data.',
        type: 'big'
      },
      {
        href: '/image',
        icon: <ProductsIcon icon="image" />,
        title: 'Scale Image',
        text: 'Comprehensive annotations for images.',
        type: 'big'
      },
      {
        href: '/video',
        icon: <ProductsIcon icon="video" />,
        title: 'Scale Video',
        text: 'Scalable annotations for video data.',
        type: 'big'
      },
      {
        href: '/text',
        icon: <ProductsIcon icon="text" />,
        title: 'Scale Text',
        text: 'Sophisticated annotations for text-based data.',
        type: 'big'
      },
      {
        href: '/audio-speech',
        icon: <ProductsIcon icon="audio" />,
        title: 'Scale Audio',
        text: 'Audio Annotation and Speech Annotation for NLP.',
        type: 'big'
      },
      {
        href: '/mapping',
        icon: <ProductsIcon icon="mapping" />,
        title: 'Scale Mapping',
        text: 'The flexible solution to develop your own maps.',
        type: 'big'
      }
    ]
  },
  others: [
    {
      title: 'Manage & Evaluate',
      content: {
        href: '/nucleus',
        icon: <ProductsIcon icon="nucleus" />,
        title: 'Scale Nucleus',
        text: 'The mission control for your data',
        type: 'big'
      }
    },
    {
      content: {
        href: '/validate',
        icon: <ProductsIcon icon="validate" />,
        title: 'Scale Validate',
        text: 'Compare and understand your models',
        type: 'big'
      }
    },
    {
      content: {
        href: '/launch',
        icon: <ProductsIcon icon="launch" />,
        title: 'Scale Launch',
        text: 'Ship and track your models in production',
        type: 'big'
      }
    },
    {
      title: 'Automate',
      content: {
        href: '/document-ai',
        icon: <ProductsIcon icon="document" />,
        title: 'Scale Document AI',
        text: 'Template-free ML document processing',
        type: 'big'
      }
    },
    {
      content: {
        href: '/content-understanding',
        icon: <ProductsIcon icon="content-understanding" />,
        title: 'Scale Content Understanding',
        text: 'Manage content for better user experiences',
        type: 'big'
      }
    },
    {
      title: 'Generate',
      content: {
        href: '/synthetic',
        icon: <ProductsIcon icon="synthetic" />,
        title: 'Scale Synthetic',
        text: 'Generate synthetic data',
        type: 'big'
      }
    }
  ]
};

const dropdownSolutions = {
  industries: {
    title: 'Industries',
    content: [
      {
        href: '/retail',
        icon: <SolutionsIcon icon="retail" />,
        title: 'Retail & eCommerce'
      },
      {
        href: '/defense',
        icon: <SolutionsIcon icon="government" />,
        title: 'Defense'
      }
    ]
  },
  useCases: {
    title: 'Use Cases',
    content: [
      {
        href: '/self-driving-cars',
        icon: <SolutionsIcon icon="autonomous-vehicles" />,
        title: 'Autonomous Vehicles'
      },
      {
        href: '/robotics',
        icon: <SolutionsIcon icon="robotics" />,
        title: 'Robotics'
      },
      {
        href: '/ar-vr',
        icon: <SolutionsIcon icon="ar-vr" />,
        title: 'AR/VR'
      },
      {
        href: '/document-ai',
        icon: <SolutionsIcon icon="document" />,
        title: 'Document Processing'
      },
      {
        href: '/content-language',
        icon: <SolutionsIcon icon="content-language" />,
        title: 'Content & Language'
      }
    ]
  }
};

const dropdownCustomers = [
  {
    href: '/customers/toyota',
    icon: <CustomersIcon icon="toyota" />,
    title: 'Toyota Research'
  },
  {
    href: '/customers/voyage',
    icon: <CustomersIcon icon="voyage" />,
    title: 'Voyage'
  },
  {
    href: '/customers/standard-cognition',
    icon: <CustomersIcon icon="standard-cognition" />,
    title: 'Standard Cognition'
  },
  {
    href: '/blog/how-to-label-1m-data-points-week',
    icon: <CustomersIcon icon="open-ai" />,
    title: 'OpenAI'
  },
  {
    href: '/customers/skydio',
    icon: <CustomersIcon icon="skydio" />,
    title: 'Skydio'
  },
  {
    href: '/customers/otto-motors',
    icon: <CustomersIcon icon="otto-motors" />,
    title: 'Otto Motors'
  },
  {
    href: '/customers/embark',
    icon: <CustomersIcon icon="embark" />,
    title: 'Embark'
  },
  {
    href: '/customers/skip',
    icon: <CustomersIcon icon="skip" />,
    title: 'Skip'
  },
  {
    href: '/customers/optimus-ride-3d',
    icon: <CustomersIcon icon="optimus-ride" />,
    title: 'Optimus Ride'
  },
  {
    href: 'https://www.wired.com/story/scale-ai-label-share-self-driving-data/',
    icon: <CustomersIcon icon="lyft" />,
    title: 'Lyft'
  },
  {
    href: '/customers/sea-machines-robotics',
    icon: <CustomersIcon icon="sea-machines" />,
    title: 'Sea Machines'
  },
  {
    href: '/customers/states-title',
    icon: <CustomersIcon icon="states-title" />,
    title: 'States Title'
  }
];

const dropdownResources = [
  {
    href: '/resources',
    icon: <ResourcesIcon icon="resources" />,
    title: 'Resource Library'
  },
  {
    href: '/blog',
    icon: <ResourcesIcon icon="blog" />,
    title: 'Blog'
  },
  {
    href: '/events',
    icon: <ResourcesIcon icon="events" />,
    title: 'Events'
  },
  {
    href: '/open-datasets',
    icon: <ResourcesIcon icon="open-datasets" />,
    title: 'Open Datasets'
  },
  {
    href: '/interviews',
    icon: <ResourcesIcon icon="interviews" />,
    title: 'Interviews'
  },
  {
    href: '/docs',
    icon: <ResourcesIcon icon="documentation" />,
    title: 'Documentation'
  }
];

const dropdownResourcesMobile = [
  {
    href: '/resources',
    icon: <ResourcesIcon icon="resources" />,
    title: 'Resource Library'
  },
  {
    href: '/blog',
    icon: <ResourcesIcon icon="blog" />,
    title: 'Blog'
  },
  {
    href: '/events',
    icon: <ResourcesIcon icon="events" />,
    title: 'Events'
  },
  {
    href: '/open-datasets',
    icon: <ResourcesIcon icon="open-datasets" />,
    title: 'Open Datasets'
  },
  {
    href: '/interviews',
    icon: <ResourcesIcon icon="interviews" />,
    title: 'Interviews'
  },
  {
    href: '/docs',
    icon: <ResourcesIcon icon="documentation" />,
    title: 'Documentation'
  },
  {
    href: '/customers',
    icon: <ResourcesIcon icon="customers" />,
    title: 'Customers'
  },
  {
    href: '/pricing',
    icon: <ResourcesIcon icon="pricing" />,
    title: 'Pricing'
  },
  {
    href: '/events/transformx',
    icon: <ResourcesIcon icon="events" />,
    title: 'Conference'
  }
];

const dropdownCompany = [
  {
    href: '/about',
    icon: <CompanyIcon icon="about" />,
    title: 'About'
  },
  {
    href: '/sales',
    icon: <CompanyIcon icon="sales" />,
    title: 'Contact'
  },
  {
    href: '/careers',
    icon: <CompanyIcon icon="careers" />,
    title: 'Careers'
  },
  {
    href: '/legal/security',
    icon: <CompanyIcon icon="security" />,
    title: 'Security'
  }
];

export const dropdownItems = {
  products: dropdownProducts,
  solutions: dropdownSolutions,
  customers: dropdownCustomers,
  resources: dropdownResources,
  resourcesMobile: dropdownResourcesMobile,
  company: dropdownCompany
};

export default dropdownItems;
